// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-image-corousel button {\n  background-color: #000000 !important;\n}\n", "",{"version":3,"sources":["webpack://./src/styles/Products.less"],"names":[],"mappings":"AAAA;EAEI,oCAAA;AAAJ","sourcesContent":[".product-image-corousel {\n  button {\n    background-color: rgb(0, 0, 0) !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
